import { defineStore } from 'pinia';

interface IPagingState {
  perPage0: number;
  page0: number;
  totalCount0: number;
}

export const usePagingStore = defineStore('paging', {
  state: (): IPagingState => ({
    perPage0: 10,
    page0: 1,
    totalCount0: 0,
  }),

  getters: {
    perPage: (state): number => state.perPage0,
    page: (state): number => state.page0,
    totalCount: (state): number => state.totalCount0,
    offsetRows: (state): number => (state.page0 - 1) * state.perPage0,
    pageCount: (state): number => Math.ceil(state.totalCount0 / state.perPage0),
  },

  actions: {
    setPerPage(count = 10) {
      this.perPage0 = count;
    },
    setPage(count = 1) {
      this.page0 = count;
    },
    setTotalCount(count = 0) {
      this.totalCount0 = count;
    },
  },
});

export default usePagingStore;
